import {
  FETCH_NEW_CONTENT_REQUEST,
  FETCH_NEW_CONTENT_SUCCESS,
  FETCH_NEW_CONTENT_FAILURE
} from '../../../Constants/actionTypes';

import { API_WHATNEW_CONTENT } from '../../../Constants/apiUrls';
import {fetchWhatNewContent} from '../../../Constants/apiService'





export const fetchNewContentRequest = () => ({
  type: FETCH_NEW_CONTENT_REQUEST,
});

export const fetchNewContentSuccess = (data) => ({
  type: FETCH_NEW_CONTENT_SUCCESS,
  payload: data,
});

export const fetchNewContentFailure = (error) => ({
  type: FETCH_NEW_CONTENT_FAILURE,
  payload: error,
});

export const fetchNewContent = () => {
  return async (dispatch, getState) => {
    dispatch(fetchNewContentRequest());

    const { auth } = getState();
    const accessToken = auth.accessToken;

    try {
   
      const data = await fetchWhatNewContent(accessToken);
      dispatch(fetchNewContentSuccess(data['new-content']));
    } catch (error) {

      let errorMessage;
      if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
        errorMessage = 'Server is currently down. Please try again later.';
      } else {
        errorMessage = error.message;
      }
      dispatch(fetchNewContentFailure(errorMessage));
    }
    
  };
};